import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {GlobalEventDispatcherService} from "../services/global-event-dispatcher/global-event-dispatcher.service";
import {Observable} from "rxjs";
import {Subject} from 'rxjs';
import {GlobalEvent} from "../services/global-event-dispatcher/global-event";

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {

  private attempts: number = 3;
  private _url: string[] = [];

  constructor(
    private _globalEventDispatcher: GlobalEventDispatcherService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestAccessToken: string = localStorage.getItem('dbUserAccessToken');

    const stream$: Subject<any> = new Subject();

    next.handle(request)
      .subscribe(
        (event: HttpEvent<any>): void => {
          stream$.next(event);
        },
        (error: any): void => {
          const accessTokenExpired: boolean = error.status === 401 && error.error && error.error.error && ['10WebError:Unauthenticated.', '10WebError:Authorization Error', 'Missing Access Token'].indexOf(error.error.error.message) !== -1;

          const url: string = request.url;
          this._url.push(url);
          const sameUrlCount = this._url.filter((_url) => _url === url).length;
          const refreshTokenRequest: boolean = url ? url.lastIndexOf('/refresh') === url.length - '/refresh'.length : false;

          if (accessTokenExpired && !refreshTokenRequest && sameUrlCount < this.attempts) {
            const currentAccessToken: string = localStorage.getItem('dbUserAccessToken');
            const accessTokenUdated: boolean = !currentAccessToken || requestAccessToken === currentAccessToken;
            if (accessTokenUdated) {
              this._globalEventDispatcher.dispatchEvent(GlobalEvent.requestFailedSessionTimeout, request, stream$);
              this._globalEventDispatcher.dispatchEvent(GlobalEvent.sessionTimeout);
            }
            else {
              this._globalEventDispatcher.dispatchEvent(GlobalEvent.requestFailedWrongToken, request, stream$);
            }
          }
          else {
            stream$.error(error);
          }
        }
      );

    return stream$;
  }
}
